// ** MUI Imports
import Card from '@mui/material/Card';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';

// ** Third Party Imports
import { ApexOptions } from 'apexcharts';
import ReactApexcharts from 'react-apexcharts';
import Tooltip from '@mui/material/Tooltip';
import { Box, LinearProgress, linearProgressClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

interface Props {
    subHeading: string;
    seriesValue: number;
    toolTip: string;
}

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
    },
}));

const ProgressChart = ({ subHeading, seriesValue, toolTip }: Props) => {
    // ** Hook
    const theme = useTheme();

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1, border: '1px solid', m: 2, borderRadius: 1 }}>
                <Box sx={{ width: `${Math.round(seriesValue)}%` }}>
                    <BorderLinearProgress variant="determinate" sx={{ height: 20 }} />
                </Box>
            </Box>
            <Box sx={{ minWidth: 80 }}>
                <Typography variant="body2" color="text.secondary">
                    {`${Math.round(seriesValue)}%`} Match
                </Typography>
            </Box>
        </Box>
    );
};

export default ProgressChart;
